import { FormControl, InputLabel, MenuItem, Select } from "@mui/material"
import { useEffect } from "react"
import { Context, DBServer } from "../../types/types";
import { useContexts, useDBServer } from "../Hooks/Hooks";

export interface DBServerPickerProps {
    setServer: Function,
    server: DBServer | undefined,
    context: Context,
    label: string,
}

function DBServerPicker(props: DBServerPickerProps) {

    const { data, refetch } = useDBServer(props.context.id)
    const servers = data ?? []

    useEffect(() => {
        if (servers.length === 0) return
        if (!props.server) props.setServer(servers[0])
        else props.setServer(servers.find(server => server.id === props.server!.id) ?? servers[0])
    }, [servers])

    const handleChange = (value: string | DBServer) => {
        props.setServer(value)
    }

    const checkServer = (): boolean => {
        return props.server !== undefined && servers.includes(props.server)
    }

    return (
        <div>
            <FormControl fullWidth>
                <InputLabel>{props.label}</InputLabel>
                <Select
                    size={"small"}
                    className=""
                    value={checkServer() ? (props.server ?? '') : ''}
                    label={props.label}
                    onChange={(event) => {
                        handleChange(event.target.value)
                    }}
                >
                    {servers.map((serverItem) =>
                        //@ts-ignore - necessary to load object into value
                        <MenuItem key={serverItem.id} value={serverItem}>
                            {serverItem.name} - {serverItem.tenant_count} Tenants
                        </MenuItem>
                    )}
                </Select>
            </FormControl>
        </div>
    )
    
}

export default DBServerPicker